module.exports = __webpack_public_path__ + "static/media/Extruded tooth8.83315341.png";